/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: IntegrationFormRouter.tsx
 🗓️ Created: 2026-01-25
 🧩 Description:
    Routes to the correct integration form based on provider type.
    - LDAP / Active Directory -> LdapConfigurationForm
    - Others (CRM, Scheduling) -> CrmConfigurationConfig
────────────────────────────────────────────────────────────────*/

import React from 'react';
import { useParams } from 'react-router-dom';
import { CrmConfigurationConfig } from './CrmConfigurationConfig';
import { LdapConfigurationForm } from './LdapConfigurationForm';

// Providers that use LDAP form
const LDAP_PROVIDERS = ['ldap', 'active_directory'];

export const IntegrationFormRouter = () => {
    const { provider } = useParams<{ provider: string }>();

    // Route to LDAP form for directory providers
    if (provider && LDAP_PROVIDERS.includes(provider)) {
        return <LdapConfigurationForm />;
    }

    // Default to CRM form for all other providers
    return <CrmConfigurationConfig />;
};
